import React, { createContext, FC, useContext } from 'react';

export const NodeDimensionContext = createContext<(width: number, height: number) => void>(() => {});

interface NodeDimensionsContextProviderProps {
    setNodeDimensions: (width: number, height: number) => void;
    children: React.ReactNode;
}

export const NodeDimensionsContextProvider: FC<NodeDimensionsContextProviderProps> = props => {
    return <NodeDimensionContext.Provider value={props.setNodeDimensions}>{props.children}</NodeDimensionContext.Provider>;
};

export function useNodeDimensions() {
    return useContext(NodeDimensionContext);
}
